import { AskForConfirmation, DetailsEditor } from "uikit"
import FaqLinks from "components/FaqLinks"
import React, { useState, useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useStore } from "store"
import { propertyTypes } from "../propertyTypes"

const PropertyDetailsView = props => {
  const [showConfirmationModal, toggleShowConfirmationModal] = useState(false)
  const [isLoanConfirmed, toggleIsLoanConfirmed] = useState(false)
  const [needLoan, toggleNeedLoan] = useState(false)

  useEffect(() => {
    window.trackEvent("edit-property", { type: props.type })
  }, [props.type])

  const askLoanConfirmation = values => {
    props.onSubmit(values).then(() => toggleShowConfirmationModal(true))
  }

  const { household, type, isNew, onSubmit, onDelete, propertyId } = props

  const { view: Worksheet } = propertyTypes[type]
  const [{ label, description, faqs }] = useStore(
    "contextuals",
    `Property: ${type}`
  )

  const heading = `${isNew ? "Add" : "Edit"} ${label} Property`
  const faqLinks = faqs.length ? <FaqLinks items={faqs} /> : null

  const loanAccountName = type === "realestate" ? "mortgage" : "auto loan"
  const loanAccountUrl =
    type === "realestate"
      ? "/organize/accounts+property/accounts/new/frm"
      : "/organize/accounts+property/accounts/new/autoloan"
  if (!showConfirmationModal && isLoanConfirmed && needLoan) {
    return <Redirect to={loanAccountUrl} />
  } else if (!showConfirmationModal && isLoanConfirmed && !needLoan) {
    return <Redirect to="/organize/accounts+property" />
  }

  const detailsEditor = property => {
    return (
      <DetailsEditor
        heading={heading}
        description={description}
        supplement={faqLinks}
      >
        <Worksheet
          success={
            propertyId === "new" ? (
              ""
            ) : (
              <Redirect to="/organize/accounts+property" />
            )
          }
          submit={propertyId === "new" ? askLoanConfirmation : onSubmit}
          onDelete={onDelete}
          isNew={isNew}
          household={household}
          property={property}
        />
        {showConfirmationModal ? (
          <AskForConfirmation
            onYes={() => {
              toggleShowConfirmationModal(false)
              toggleIsLoanConfirmed(true)
              toggleNeedLoan(true)
            }}
            onNo={() => {
              toggleShowConfirmationModal(false)
              toggleIsLoanConfirmed(true)
            }}
            header="Confirm"
            render={() => (
              <span>Do you have a {loanAccountName} for this property?</span>
            )}
          />
        ) : null}
      </DetailsEditor>
    )
  }
  if (isNew) {
    return detailsEditor(null)
  }

  return (
    <PropertyDetailsEditor
      propertyId={propertyId}
      detailsEditor={detailsEditor}
    />
  )
}

const PropertyDetailsEditor = props => {
  const [property] = useStore("properties", props.propertyId)
  return props.detailsEditor(property)
}

export default PropertyDetailsView
